// extracted by mini-css-extract-plugin
export default {"controls":"InventorySheetPageHeaderComponent_controls__TCEvI"};